var map = {
	"./book_1.png": "TP0Q",
	"./code_1.png": "ZabE",
	"./conversation_1.png": "4457",
	"./error_1.png": "oN2j",
	"./fire_1.png": "4jJq",
	"./flag_1.png": "DJzx",
	"./gutachten_1.png": "ciY6",
	"./handshake_1.png": "kba4",
	"./lab_1.png": "GoA+",
	"./lightbulb_1.png": "YisQ",
	"./note_1.png": "a7uv",
	"./person_1.png": "BTpn",
	"./present_1.png": "Fb1X",
	"./quote_1.png": "rFrE",
	"./search_1.png": "Ak/V",
	"./statistics_1.png": "m4Qf",
	"./target_1.png": "sjNX",
	"./warning_1.png": "WRfO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zfua";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*_1\.png$
// module id = Zfua
// module chunks = 1